import script from "./esSpecialDaysSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esSpecialDaysSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esSpecialDaysSettings.vue?vue&type=style&index=0&id=12024322&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12024322"]])

export default __exports__